import Vue from 'vue'

export const bus = new Vue()

export const EVENTS = {
  HASHTAG_CLICKED: 'HASHTAG_CLICKED',
}
